/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'changeBckgd': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g fill-rule="nonzero" _fill="none"><circle pid="0" _fill="#8300BF" cx="12" cy="12" r="12"/><path pid="1" d="M17.5 5.5v8H13V16h4.5v1h-11v-1H11v-2.5H6.5v-8h11zm-1 1h-9v6h9v-6z" _fill="#FFF"/></g>'
  }
})
